import React, { useState } from "react";
import axios from "./../../../utils/axiosInstance";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import "./Register.css";

function Register() {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirmation) {
      toast.error("Password confirmation failed!");
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASED_URL}/auth/register`,
          { name, email, phoneNumber, password }
        );
        if (response.status === 200) {
          toast.success(response.data.message);
          // Save email to localStorage
          localStorage.setItem("emailForVerification", email);
          // Redirect to a confirmation page
          navigate("/verifyEmail");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="container mx-auto flex justify-center items-center h-screen">
      <div className="w-full md:w-7/12 flex flex-col items-center justify-center">
        <form
          style={{ width: "80%", maxWidth: 500 }}
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <h1 className="text-center text-3xl font-bold mb-4">
            Create an account
          </h1>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2" htmlFor="name">
              Name
            </label>
            <input
              type="text"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-2"
              htmlFor="username"
            >
              Phone Number
            </label>
            <input
              type="text"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="username"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter your phone number"
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-2"
              htmlFor="password_confirmation"
            >
              Password Confirmation
            </label>
            <input
              type="password"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="password_confirmation"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              placeholder="Password Confirmation"
            />
          </div>
          <div className="flex justify-center mb-4 mt-8">
            <button
              type="submit"
              className="text-white bg-blue-700 hover:bg-blue-800 rounded px-4 py-2"
            >
              Sign Up
            </button>
          </div>
          <div className="py-4">
            <div className="text-center">
              <small>
                Already have an account ?{" "}
                <Link
                  to={"/login"}
                  className="text-decoration-none text-blue-600 hover:text-blue-800"
                >
                  Log in
                </Link>
              </small>
              {/* <div className="my-3">
                <small>OR</small>
              </div> */}
              <div className="flex justify-center">
                <div id="google-signin"></div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="register__bg h-[92vh] w-[80vh] bg-cover bg-center"></div>
    </div>
  );
}

export default Register;
